import { Archive } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconArchive12Line = createIcon(Archive, 12, "Line");
export const IconArchive16Line = createIcon(Archive, 16, "Line");
export const IconArchive20Line = createIcon(Archive, 20, "Line");
export const IconArchive24Line = createIcon(Archive, 24, "Line");
export const IconArchive32Line = createIcon(Archive, 32, "Line");
export const IconArchive48Line = createIcon(Archive, 48, "Line");
export const IconArchive64Line = createIcon(Archive, 64, "Line");
